import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { filter, find } from "lodash";

interface IPolicyEvaluatorPicker {
  label: string;
  policies: any[];
  initialValue: any[];
  helperText?: string;
  onChange: (selectedPolicies: string[]) => void;
}

const PolicyEvaluatorPicker: React.FC<IPolicyEvaluatorPicker> = ({
  label,
  policies,
  helperText = "",
  initialValue,
  onChange,
}) => {

  const handleChange = (value: any) => {
    onChange(value);
  };

    return (
    <>
        <Autocomplete
            multiple
            options={policies}
            getOptionLabel={(option): any => find(policies, { id: option?.id }).name }
            sx={{ maxWidth: "90%", textAlign: 'left', mt: 2 }}
            size="medium"
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(e, value: any) => {
                handleChange(value);
            }}
            value={initialValue}
            clearOnBlur
            disableCloseOnSelect
            filterOptions={(options, params) => {
              const filtered = filter(options, function (item: any) {
                return item.id.indexOf(params.inputValue) > -1;
              });
  
              return filtered;
            }}
            renderOption={(props, option) => {
                return (
                  <li {...props} key={option.id}>
                    <Box sx={{ maxWidth: "800px" }}>
                        <Typography variant="body1">{option.name}</Typography>
                        <Typography variant="body2" color="text.secondary">{option.description}</Typography>
                    </Box>
                  </li>
                );
              }}
            renderInput={(params): JSX.Element => {
              return <TextField
                name={label}
                variant="outlined"
                label={label}
                helperText={helperText}
                {...params}
              />
            }}
          />
    </>
  );
};

export default PolicyEvaluatorPicker;
